import { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { IconName } from '@optimus-web/icons';
import { isOpened, close, open, isSalesForceChatOpen } from '@mews-commander/chat';
import { NavbarIconButton } from '../../../components';

interface Props {
    isOpened: boolean;
    open(): void;
    close(): void;
}

class ChatButton extends Component<Props> {
    handleClick = () => {
        if (isSalesForceChatOpen()) {
            this.props.close();
        } else {
            this.props.open();
        }
    };

    render() {
        return (
            <NavbarIconButton
                icon={IconName.HelpCenter}
                title={<LocalizedText textKey={TextKey.HelpCenterButtonTooltip} />}
                onClick={this.handleClick}
            />
        );
    }
}

export default connect(
    createStructuredSelector({
        isOpened,
    }),
    {
        open,
        close,
    }
)(ChatButton);
